import React from "react";
// import { useWorldContract } from "../../../mud/useWorldContract";
// import { Severity } from "@eveworld/types";
//import setBringOffline from "../../systemCalls/handleBringOffline";
import { EveButton } from "@eveworld/ui-components";
// import { useNotification } from "@eveworld/contexts";

interface ButtonProps {
  AssemblyId: string;
}

const ButtonDappLink: React.FC<ButtonProps> = ({ AssemblyId }) => {
  //   const { worldContract } = useWorldContract();
  //   const { notify } = useNotification();

  const handleDappLink = async (SmartObjectId: string) => {
    // const txHash = await setBringOffline({
    //   worldContract,
    //   smartObjectId: SmartObjectId,
    // });
    // if (txHash) {
    //   notify({ type: Severity.Success, txHash });
    // } else {
    //   notify({
    //     type: Severity.Error,
    //     message: "Transaction failed to execute",
    //   });
    // }
    //https://blockchain-gateway-stillness.live.tech.evefrontier.com/config
    //Grab baseDappUrl from that and then append ?smartObjectId={objectId} (replace {objectId}).
    window.open(
      "https://smart-assembly-base.stillness.evefrontier.com/?smartObjectId=" +
        AssemblyId,
      "_blank"
    );
  };

  return (
    <EveButton typeClass="primary" onClick={() => handleDappLink(AssemblyId)}>
      Dapp Link
    </EveButton>
  );
};

export default React.memo(ButtonDappLink);
